import React, { useCallback, useEffect } from "react";
// import WBack from "../../../public/images/blackjack/wrewards-back.svg";
// import WBack from "../../../public/images/blackjack/back-new.png";
// import WBack from "./back-w.svg";
// import ClubsIcon from "../../../public/images/blackjack/clubs.svg";
// import HeartIcon from "../../../public/images/blackjack/heart.svg";
// import SpadesIcon from "../../../public/images/blackjack/spades.svg";
// import DiamondsIcon from "../../../public/images/blackjack/diamonds.svg";
import ClubsIcon from "../../../public/images/blackjack/clubs-front-2.svg";
import HeartIcon from "../../../public/images/blackjack/heart-front-2.svg";
import SpadesIcon from "../../../public/images/blackjack/spades-front-2.svg";
import DiamondsIcon from "../../../public/images/blackjack/diamonds-front-2.svg";
import WBack from "/public/images/blackjack/back-new-1.svg";
import { cardMapper, CardSuit } from "./helpers";
import { Card, CardBack, CardFront } from "./styles";
import { useLocalStorage } from "usehooks-ts";
import { LS_SOUND_KEY } from "types/local-storage";

type Props = {
  id: number | "hidden" | "deck";
  isShouldFlipped?: boolean;
  delay?: number;
  isBackInitial?: boolean;
  setAnimationLoading?: () => void;
};

const ICONS = {
  [CardSuit.DIAMOND]: DiamondsIcon,
  [CardSuit.HEART]: HeartIcon,
  [CardSuit.SPADE]: SpadesIcon,
  [CardSuit.CLUB]: ClubsIcon,
};

const BlackjackCard: React.FC<Props> = ({
  id,
  isShouldFlipped = true,
  delay = 0,
  isBackInitial,
}) => {
  const [isFlipped, setIsF] = React.useState(isBackInitial ?? true);

  const [isSoundEnabled] = useLocalStorage(LS_SOUND_KEY, true, {
    initializeWithValue: true,
  });
  const flipAudioRef = React.useRef<any>();

  const playFlipDeckSound = useCallback(() => {
    if (isSoundEnabled && flipAudioRef.current) {
      flipAudioRef.current.currentTime = 0;
      flipAudioRef.current.play?.().catch(() => {});
    }
  }, [isSoundEnabled, flipAudioRef]);

  useEffect(() => {
    if (flipAudioRef.current) {
      flipAudioRef.current.muted = !isSoundEnabled;
    }
  }, [isSoundEnabled]);

  // const flipAudioRef = React.useRef<any>();

  useEffect(() => {
    const flp = setTimeout(() => {
      if (isShouldFlipped) {
        setIsF(() => false);
        playFlipDeckSound();
      }
    }, delay);

    return () => clearTimeout(flp);
  }, [isShouldFlipped]);

  React.useEffect(() => {
    if (typeof window !== undefined) {
      flipAudioRef.current = new Audio("/audio/blackjack/flip.wav");
    }
  }, []);

  const card =
    typeof id === "number"
      ? (cardMapper.get(id) ?? { name: "", value: "", suit: CardSuit.DIAMOND, label: "" })
      : { name: "", value: "", suit: CardSuit.DIAMOND, label: "" };

  const Icon = ICONS[card.suit];

  return (
    <Card isFlipped={isFlipped}>
      <div className="inner">
        <CardFront>
          <div className={`name left ${card.suit.toLocaleLowerCase()}`}> {card.label}</div>
          <div className={`icon ${card.suit.toLocaleLowerCase()}`}>
            <Icon />
          </div>
          <div className={`name right ${card.suit.toLocaleLowerCase()}`}> {card.label}</div>
        </CardFront>
        <CardBack>
          <WBack className="icon" style={{ objectFit: "contain" }} />
        </CardBack>
      </div>
    </Card>
  );
};

export default BlackjackCard;
